"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewStatus = void 0;
exports.ReviewStatus = {
    NotRequested: "not_requested",
    Pending: "pending",
    Declined: "declined",
    Allowed: "allowed",
    AllowedWithChanges: "allowed_with_changes",
};
